import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import * as Constant from '../../../constants/actionTypes';
import { labelName } from '../../UtilsWeb';
import styles from './styles';

class DialogBox extends PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  handleClose = confirm => {
    const { toggle } = this.props;
    toggle(confirm);
  };

  render() {
    const { classes, open: isOpen, dialogTitle, dialogContentText } = this.props;
    return (
      <div>
        <Dialog
          open={isOpen}
          onClose={this.handleClose}
          title="alert-dialog"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="responsive-dialog-title">{dialogTitle}</DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <DialogContentText className={classes.contentTextStyle}>
              {' '}
              {dialogContentText}
            </DialogContentText>
          </DialogContent>
          <div className={classes.buttonWrapper}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.handleClose(Constant.FALSE)}
              className={classes.btn}
              autoFocus
            >
              {labelName(Constant.LABEL_CANCEL)}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.handleClose(Constant.TRUE)}
              className={classes.btn}
              autoFocus
            >
              {labelName(Constant.LABEL_OK)}
            </Button>
          </div>
          <DialogActions className={classes.dialogActions} />
        </Dialog>
      </div>
    );
  }
}

DialogBox.propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  dialogTitle: PropTypes.string.isRequired,
  dialogContentText: PropTypes.string.isRequired,
};

export default withStyles(styles)(DialogBox);
